import React from 'react';
import ReduxToastr from 'react-redux-toastr';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';

export default () => (
  <ReduxToastr timeOut={4000}
               newestOnTop={false}
               preventDuplicates
               position='top-right'
               transitionIn='fadeIn'
               transitionOut='fadeOut'
               progressBar />
);



// WEBPACK FOOTER //
// ./src/lib_react_frontend/componentes/ApiceToaster.jsx